export function extractLawFirmIdFromUserResponse(response) {
  if (!response) {
    return "";
  }

  const nestedLawFirmId = response.law_firm_location?.law_firm?.lawfirm_id;
  if (nestedLawFirmId) {
    return nestedLawFirmId;
  }

  const locationLawFirmId = response.law_firm_location?.lawfirm_id;
  if (locationLawFirmId) {
    return locationLawFirmId;
  }

  if (response.lawfirm_id) {
    return response.lawfirm_id;
  }

  return "";
}

export function extractLocationIdFromUserResponse(response, routeLocationId) {
  return (
    response?.law_firm_location?.law_firm_location_id ||
    response?.law_firm_location_id ||
    routeLocationId ||
    ""
  );
}

export function resolveLawFirmUserSelection(response, routeLocationId) {
  const lawFirmId = extractLawFirmIdFromUserResponse(response);
  if (!lawFirmId) {
    console.warn(
      "Could not extract law firm ID from law firm user response:",
      response
    );
  }

  return {
    lawFirmId,
    locationId: extractLocationIdFromUserResponse(response, routeLocationId),
  };
}

export function resolveLawFirmUserResetSelection(response, routeLocationId) {
  const lawFirmId = extractLawFirmIdFromUserResponse(response);

  return {
    lawFirmId,
    locationId: extractLocationIdFromUserResponse(response, routeLocationId),
    shouldFetchLocations: Boolean(lawFirmId),
  };
}
